import React from 'react';

export type SystemContextProps = {
    systemName: string | null,
    setSystemName: (value: string | null) => void,
    apiVersion: string | null,
    setApiVersion: (value: string | null) => void,
    minAppVersion: string | null,
    setMinAppVersion: (value: string | null) => void,
};

const SystemContext: React.Context<SystemContextProps> = React.createContext<SystemContextProps>({
    systemName: null,
    setSystemName: () => {},
    apiVersion: null,
    setApiVersion: () => {},
    minAppVersion: null,
    setMinAppVersion: () => {},
});

export default SystemContext;